<template>
    <div>
        <CForm
                ref="searchForm"
                @onSubmit="onSubmit"
                @onReset="onReset"
                :structure="structure"
                :options="{ submit: { text: 'Rechercher', variant: 'info'}, reset: { text: 'Réinitialiser', variant: 'light'} }">
        </CForm>
    </div>
</template>
<script>
    import CForm from './CForm'
    export default {
        name: 'SearchForm',
        components: {
            CForm: () => import('./CForm')
        },
        props: {
            caption: {
                type: String,
                default: ''
            },
            structure: {
                type: Object,
                default: function () {
                    return {}
                }
            },
        },
        data: function () {
            return {}
        },
        methods: {
            getFormFieldRefs() {
                return this.$refs.searchForm.fieldRefs
            },
            onSubmit(form, fieldRefs, structure) {
                this.$emit('onSubmit', form, fieldRefs, structure)
            },
            onReset(form, fieldRefs, structure) {
                this.$emit('onReset', form, fieldRefs, structure)
            }
        }
    }
</script>

